import { PaymentService } from './paymentService';

// Assign PaymentService to window global scope
window['PaymentService'] = new PaymentService();



// WEBPACK FOOTER //
// ./src/index.ts